export default __webpack_public_path__ + "static/media/About_B_Mobile.9d9aa2c3.png";